import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PlanListPage } from './list';
import { PlanCreation } from './create';

export const PlansModule = () => {
  return (
    <Routes>
      <Route path="/:id" element={<PlanCreation />} />
      <Route path="*" element={<PlanListPage />} />
    </Routes>
  );
};
